export default __webpack_public_path__ + "static/media/Frame 179.8a707e23.svg";